// Card chrome shared by the three global-controls cards — same muted header strip + bordered cells as the grid.
export function RailCard({ title, right, children, testId }) {
  return (
    <section className="flex min-w-0 flex-col overflow-hidden rounded-lg border border-slate-200 bg-white" data-testid={testId}>
      <header className="flex h-8 shrink-0 items-center gap-2 border-b border-slate-200 bg-slate-50 px-3">
        <h4 className="th-std tracking-wide">{title}</h4>
        {right && <div className="ml-auto flex items-center gap-1.5">{right}</div>}
      </header>
      <div className="divide-y divide-slate-100">{children}</div>
    </section>
  );
}

export function RailRow({ label, hint, children, testId, strong, className = "" }) {
  return (
    <div className={`flex min-h-[30px] items-center justify-between gap-3 px-3 py-1 text-xs ${strong ? "bg-slate-50" : ""} ${className}`} data-testid={testId}>
      <span className={`min-w-0 truncate ${strong ? "font-bold text-slate-900" : "text-slate-500"}`} title={hint}>{label}</span>
      <div className="flex shrink-0 items-center gap-1.5">{children}</div>
    </div>
  );
}

export const railInputBase = "h-7 rounded-md border border-slate-200 bg-background px-1.5 text-xs tabular-nums outline-none focus:border-brand focus:ring-1 focus:ring-brand disabled:cursor-not-allowed disabled:opacity-50 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none";
export const railInput = `${railInputBase} w-16 text-right`;

export const railLink = "text-[11px] font-medium text-brand hover:underline disabled:opacity-50 disabled:no-underline";

const CHIP = {
  auto: "bg-emerald-50 text-emerald-700 border-emerald-200",
  manual: "bg-amber-50 text-amber-800 border-amber-300",
  off: "bg-slate-100 text-slate-500 border-slate-200",
};
export function Chip({ kind = "off", title, testId, children }) {
  return <span className={`inline-flex items-center rounded border px-1.5 py-px text-[10.5px] font-semibold tabular-nums ${CHIP[kind]}`} title={title} data-testid={testId}>{children}</span>;
}
